import React, { useCallback, useState } from "react";
import RoutingModal from "@commonComponents/routingModal";
import { useContainer } from "@EUForms/hooks/useContainer";
import { CustomLoader } from "@commonComponents/formComponents/loader";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { AddBtn } from "@commonComponents/AddBtn";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";
import MarkedDeleted from "../../DMS_App/formSections/items/markedDeleted";

const RepeatableSealNumber = (props) => {
  const {
    containerId,
    sealsList,
    containerTabActions,
    disabled,
    isRFI,
    isContainerDisabled
  } = props

  const { isDisabled, isRFIDisabled } = useCurrentShipmentType()
  const [sealNumber, setSealNumber] = useState('')
  const {
    addContainerFieldSealNumber,
    updateContainerFieldSealNumber,
    deleteContainerFieldSealNumber
  } = containerTabActions

  const { isLoading, addItem, updateItem, saveItem, deleteItem } = useContainer({
    containerKey: 'containerTab',
    listKey: 'containersList',
    tableName: 'sealsList',
    addData: addContainerFieldSealNumber,
    updateData: updateContainerFieldSealNumber,
    deleteData: deleteContainerFieldSealNumber
  })
  const onMarkContainerSealNumberDelete = useCallback((data, { id }) => {
    if (data.checked) {
      updateItem(containerId, id, { markDelete: '1' })
      saveItem(containerId, { id, markDelete: '1' })
    } else {
      updateItem(containerId, id, { markDelete: '0' })
      saveItem(containerId, { id, markDelete: '0' })
    }
  },[containerId])
  return (
    <>
      <InputField
        id={`seal${containerId}`}
        type='text'
        label='SEAL'
        boxNumber={'7/18'}
        isDisabled={disabled}
        name='sealNumber'
        value={sealNumber}
        clearInput={false}
        onChange={(e, { value }) => setSealNumber(value)}
      />
      <AddBtn
        text='ADD'
        size='mini'
        className='addrepeatBtn'
        style={{ fontSize: '8px' }}
        disabled={!sealNumber || window.typeOfUser === 'BROKER_KN_ADMIN'}
        onClick={async () => {
          await addItem(containerId, { sealNumber: sealNumber })
          setSealNumber('')
        }}
      />
      {isLoading && <CustomLoader />}
      <RoutingModal
        isFormDisabled={disabled === false ? false : isDisabled}
        headerName='SEAL_NUMBERS'
        triggerContent={
          <span
            disabled={window.typeOfUser === 'BROKER_KN_ADMIN'}
            style={{
              top: '48%',
              position: 'relative',
              marginLeft: '5px',
              marginRight: '5px',
              fontWeight: '800',
              color: 'blue',
              cursor: 'pointer',
            }}
          >
            +{sealsList?.length}
          </span>
        }
        valueKey='sealNumber'
        limit={99}
        AddItem={() => addItem(containerId)}
        saveData={(data) => saveItem(containerId, data)}
        updateData={(id, data) => updateItem(containerId, id, data)}
        deleteData={(id) => deleteItem(containerId, id)}
        dataList={sealsList}
        dataSource={[]}
        fieldType={'input'}
        countryCode='ES-AES'
        disableAddBtn={true}
        isRFI={isRFI}
        isParentDisabled={isContainerDisabled}
        markedDeleted={isRFI ? (params) => <MarkedDeleted
          label='_'
          className='marked-deleted marked-deleted-label-hidden'
          disabled={(isRFIDisabled||isContainerDisabled)}
          checked={(isContainerDisabled||params?.markDelete||false)}
          onChange={
            (e, data) => onMarkContainerSealNumberDelete(data, params)
          }
        /> : null}
      />
    </>
  )
}

export default RepeatableSealNumber